// src/components/layout/Topbar.js
import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { getInitials } from '../../utils/helpers';
import LanguageSwitcher from '../common/LanguageSwitcher';

const Topbar = ({ onMenuToggle, menuOpen, title, subtitle }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="topbar">
      <button
        className="btn p-0 me-2"
        style={{ color: '#475569', fontSize: 20 }}
        onClick={onMenuToggle}
      >
        {menuOpen ? <span className='text-primary'>☰</span> : <span className='text-danger'>✕</span> }
      </button>

      <div className="topbar-title">
        <h4>{title || 'Dashboard'}</h4>
        {subtitle && <p>{subtitle}</p>}
      </div>

      <div className="topbar-actions">
        <LanguageSwitcher />

        <button className="icon-btn" title="Notifications">
          🔔
          <span className="badge-dot" />
        </button>

        <div style={{ position: 'relative' }}>
          <div
            className="user-avatar"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            title={user?.username}
          >
            {getInitials(user?.username || 'Admin')}
          </div>
          {dropdownOpen && (
            <div
              style={{
                position: 'absolute', right: 0, top: '110%',
                background: '#fff', borderRadius: 10, boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                minWidth: 180, zIndex: 9999, padding: '8px 0',
              }}
            >
              <div style={{ padding: '8px 16px', borderBottom: '1px solid #f1f5f9' }}>
                <div style={{ fontWeight: 700, fontSize: 13 }}>{user?.username}</div>
                <div style={{ fontSize: 12, color: '#64748b' }}>Administrator</div>
              </div>
              <button
                onClick={() => navigate('/admin')}
                style={{ display: 'block', width: '100%', padding: '8px 16px', background: 'none', border: 'none', textAlign: 'left', fontSize: 13, cursor: 'pointer' }}
              >
                ⚙️ Settings
              </button>
              <button onClick={()=> navigate("/profile")}
                style={{ display: 'block', width: '100%', padding: '8px 16px', background: 'none', border: 'none', textAlign: 'left', fontSize: 13, cursor: 'pointer' }}
              >
                ⚙️ Profile
              </button>
              
              <button onClick={() => navigate('/tickets')}
                style={{ display: 'block', width: '100%', padding: '8px 16px', background: 'none', border: 'none', textAlign: 'left', fontSize: 13, cursor: 'pointer' }}
              >
                ⚙️ Technical Support
              </button>

              <button
                onClick={handleLogout}
                style={{ display: 'block', width: '100%', padding: '8px 16px', background: 'none', border: 'none', textAlign: 'left', fontSize: 13, cursor: 'pointer', color: '#ef4444' }}
              >
                🚪 Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;